import { Card, Text, Title } from "@mantine/core";

export function StatsKpiCard(props: { readonly label: string; readonly value: string | number }) {
  const display = typeof props.value === "number" ? props.value.toLocaleString() : props.value;
  return (
    <Card shadow="xs" padding="md" radius="md" withBorder>
      <Text size="xs" c="dimmed" mb={4}>
        {props.label}
      </Text>
      <Title order={3}>{display}</Title>
    </Card>
  );
}
